<h1 mat-dialog-title align="center">{{message}}</h1>

<div mat-dialog-actions align="center" class="flex flex-col">
    <form [formGroup]="confirmationForm" class="w-full">
        <mat-form-field class="w-full">
            <input type="text" matInput required maxlength="30"
                formControlName="formName" [placeholder]="placeholder">
            <!-- <mat-error>
                   <span *ngIf="isUniqueName"> Form name already exist, please try another name.</span>
            </mat-error> -->
        </mat-form-field>
    </form>
    <div align="center" class="w-full">
        <button mat-raised-button (click)="onNoClick()" color="warn">Cancel</button>
        <button mat-raised-button color="primary"
            [disabled]="confirmationForm.invalid" (click)="onSubmit()">Yes</button>
    </div>
</div>